import { DataBean } from "../DataBean";

export class TimeEventStandard extends DataBean {



    public async createTimeEventStandardForProductionOrder(idProductionOrder:any,productionOrderDate:any,accountantDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createTimeEventStandardForProductionOrder_Number_java.util.Date_java.util.Date_Number", [idProductionOrder,productionOrderDate,accountantDate,idEmployee]);
    }
    
}